var CCApplyNow = function() {};

CCApplyNow.prototype.init = function() {
  var clickHandler = function(e) {
    e.preventDefault();

    // Generate redirection UUID
    var redirectionUuid = uuidv4();

    // Append redirection_uuid param to redirect URL
    var redirectUrl = e.currentTarget.href + '?redirection_uuid=' + redirectionUuid;

    // Fire GTM event
    this.fireGtmEvent(redirectionUuid);

    window.open(redirectUrl);
  };

  $('.cc-apply-now').on('click', clickHandler.bind(this));
};

CCApplyNow.prototype.fireGtmEvent = function(redirectionUuid) {
  var dataObj = {
    event: 'CC-ApplyNow',
    ccRedirectionUuid: redirectionUuid
  }

  window.GoogleTagManager.push(dataObj);
  console.log('GTM event', dataObj);
};

// Boot
(new CCApplyNow()).init();